import { render, staticRenderFns } from "./AddEmployeeDetail.vue?vue&type=template&id=6c1824c8"
import script from "./AddEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./AddEmployeeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports